import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchProducts, showProduct, reset } from '../../actions/product';
import * as uri from '../../config/uri';
import { setProduct } from '../../actions/product';
import { setCurrentCategoryIndex } from '../../actions/api';

import ProductContainerRender from "../ProductContainerRender/ProductContainerRender";
import { getCategories } from '../../selectors/configSelectors';
import { pushWithQueryParams } from '../../services/uri';

class ProductContainer extends Component {
  getCategoryParam = () => {
      return this.props.match.params.category;
  }
 
  componentDidMount() {
    const path = this.props.router.location.pathname;
    if (path !== uri.rootPageUri && !path.includes('reset')) {
      this.props.go(uri.rootPageUri);
    }

    this.props.reset();
  }

  render() {
    return <ProductContainerRender/>;
  }
}

const mapStateToProps = (state) => {
  return {
    router : state.router,
    categories: getCategories(state),
    view: state.view,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      setCurrentCatIdx: (idx) => dispatch(setCurrentCategoryIndex(idx)),
      go: (path) => dispatch(pushWithQueryParams(path)),
      showProduct: (index) => dispatch(showProduct(index)),
      fetchProducts: () => dispatch(fetchProducts()),
      reset: () => dispatch(reset()),
      setCurrentProduct: (product) => dispatch(setProduct(product)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainer);



// WEBPACK FOOTER //
// ./src/components/ProductContainerInfinity/ProductContainerInfinity.jsx